import {gql} from "@apollo/client";

export const NEW_RUN_FROM_EXISTING_STEP = gql`
	mutation newRunFromExistingStep ($jobRunId: Int!, $jobStepRunId: Int!) {
		newRunFromExistingStep(input: {jobRunId: $jobRunId, jobStepRunId: $jobStepRunId}) {
			jobRun {
			  id
			}
		   errors {
				... on ArgumentError {
					message
				}
			}
		}
	}
`;
